import { useState } from 'react'

import Paper from '@mui/material/Paper'

import StyledTable from '@components/StyledTable'
import { toFilterOptions } from '@util/filter'

import { useCombiWerkbakken } from '../../../aansluiting/dashboard/hooks/useCombiWerkbakken'
import { useAutosuggest } from '../../../autosuggest/hooks/useAutosuggest'
import { ENTITIES } from '../../../entity'
import { Page } from '../../../theme/components/Page'
import { PageSection } from '../../../theme/components/PageSection'
import { useAansluitingValuelists } from '../../../valuelists/hooks/useAansluitingValuelists'
import { useValuelists } from '../../../valuelists/hooks/useValuelists'
import { CombiOpdrachtenFilters } from '../components/CombiOpdrachtenFilters'
import { CombiOpdrachtenTableRow } from '../components/CombiOpdrachtenTableRow'
import { useCombiOpdrachtenSearch } from '../hooks/useCombiOpdrachtenSearch'

const headerCells = [
  { id: 'kpi', numeric: false, label: '', sort: false, fixed: 40 },
  { id: 'opdrachtId', numeric: true, label: 'Opdracht id', sort: false },
  { id: 'clusterId', numeric: false, label: 'Cluster id', sort: false },
  { id: 'realisatiedatum', label: 'Plandatum', sort: true },
  { id: 'discipline', label: 'Discipline', sort: false, fixed: 50 },
  { id: 'adres', numeric: false, label: 'Adres', sort: false },
  { id: 'netbeheerder', numeric: true, label: 'Netbeheerder', sort: false },
  { id: 'aannemer', numeric: true, label: 'Uitvoerende', sort: false },
  { id: 'gebiedsCodeLabel', numeric: false, label: 'Gebied', sort: false },
  {
    id: 'statusText',
    numeric: false,
    label: 'Status',
    sort: false,
    fixed: 130,
  },
  { id: 'changed', label: 'Mutatiedatum', sort: true, fixed: 75 },
  { id: 'details', label: 'Details', sort: false, fixed: 150 },
] as const

export const CombiOpdrachten = () => {
  const { data: valuelists } = useValuelists()
  const { data: aansluitingValuelists } = useAansluitingValuelists()
  const {
    data: { items: opdrachten, count, skip, limit },
    isLoading,
    isError,
    initialFilters,
    onChangeFilters,
    onChangeSort,
    onChangePage,
    filters,
    sort,
    onReset,
    onRefresh,
  } = useCombiOpdrachtenSearch()
  const { data: werkbakken } = useCombiWerkbakken()

  const [searchText, setSearchText] = useState('')
  const { data: options } = useAutosuggest({
    text: searchText,
    entityType: ENTITIES.OPDRACHT,
  })

  return (
    <Page
      title={['Combi opdrachten', 'Aansluiting']}
      breadcrumbs={[
        { label: 'Aansluiting', href: '/home', tooltip: 'CAPO home' },
        { label: 'Combi opdrachten' },
      ]}
      fillScreen
    >
      <PageSection
        id="combiopdrachten"
        heading="Overzicht van alle combi opdrachten in uw gebied"
      />

      <Paper>
        <CombiOpdrachtenFilters
          onChange={onChangeFilters}
          filters={filters}
          initialFilters={initialFilters}
          onSearchChange={(search) => setSearchText(search)}
          options={options}
          onRefresh={onRefresh}
          onReset={onReset}
          werkbakken={werkbakken}
          filterOptions={{
            ...valuelists,
            ...aansluitingValuelists,
            labels: toFilterOptions(aansluitingValuelists.labels),
          }}
        />
        <StyledTable
          onChangeSort={onChangeSort}
          onChangePage={onChangePage}
          headerCells={headerCells}
          sort={sort}
          isError={isError}
          stats={{ count, skip, limit }}
          loading={isLoading}
        >
          {opdrachten.map((opdracht) => (
            <CombiOpdrachtenTableRow
              key={opdracht.opdrachtId}
              opdracht={opdracht}
              showProjectOptions
            />
          ))}
        </StyledTable>
      </Paper>
    </Page>
  )
}
